import { IsArray } from "@pdfking/tfunc"

/**
 * Checks if value is an object (not array).
 *
 * @param obj - Value to check
 * @returns True if object but not array
 */
export const is_object = obj => obj instanceof Object && !IsArray(obj)
